import React, { useState } from 'react';
import styles from './Pagination.scss';
import Pagination from 'react-responsive-pagination';

export interface PaginationProps {
  /**
   * Total number of rows
   */
  totalRows: number;
  /**
   * Rows per page
   */
  rowsPerPage: number;
  /**
   * Rows being skipped to display the current page
   */
  rowsToSkip: number;
  /**
   * Page selected specfying number of rows to skip
   */
  onChange: (v: number) => void;
}
export const PaginationProvider: React.FC<PaginationProps> = (props) => {
  const total = Math.ceil(props.rowsPerPage > 0 ? Math.abs(props.totalRows / props.rowsPerPage) : 0);

  const [currentPage, setCurrentPage] = useState(0);
  const handlePageChange = (p: number) => {
    props.onChange && props.onChange((p - 1) * props.rowsPerPage);
    setCurrentPage(p);
  };

  return (
    <Pagination
      total={total}
      current={currentPage}
      onPageChange={(p) => handlePageChange(p)}
      previousLabel="Back"
      nextLabel="Next"
      extraClassName={`${styles['acma-pagination']}`}
      activeItemClassName={`active ${styles['acma-pagination-active']}`}
    />
  );
};
